import { connect } from 'react-redux';
import GenericDimensionPageStep from '../components/GenericDimensionPageStep';
import { getGenericDimensionPageStep } from '../selectors';
import { setDimensionFilter, addFutureChanged, stepValidationStatusChanged } from '../actions';

const mapStateToProps = (state, ownProps) => ({
    ...getGenericDimensionPageStep(ownProps.dimension)(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    setDimensionFilterValues: values => dispatch(setDimensionFilter(ownProps.dimension, values)),
    enableAddFuture: () => dispatch(addFutureChanged(ownProps.dimension, true, true)),
    onStepValidationStatusChanged: stepValidationStatus => dispatch(stepValidationStatusChanged(stepValidationStatus)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GenericDimensionPageStep);
